module.exports = __webpack_public_path__ + "img/logo-illuminate.157d247a.png";